import IconComponent from "icons/IconComponent";

import UserInfoIcon from "./user-info.svg";

export default (UserInfoIcon as any) as IconComponent;
